import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { ArticleService } from 'src/app/services/articles/article.service';

@Component({
  selector: 'app-articles-view',
  imports: [CommonModule, MarkdownModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './articles-view.component.html',
  styleUrl: './articles-view.component.scss',
})
export class ArticlesViewComponent {
  articleId: string = '';

  constructor(
    protected route: ActivatedRoute,
    public articleService: ArticleService,
    public router: Router
  ) {
    this.articleId = this.route.snapshot.paramMap.get('id') ?? '';
  }
}
